import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthService from '../../services/authService';

function useForceInit() {
  const [searchParams] = useSearchParams();
  const authService = new AuthService();

  useEffect(() => {
    if (searchParams.get('force_init') == 'true' && !searchParams.get('tenant_token')) {
      authService.signInRedirect();
    }
  }, [searchParams]);

  return;
}

export default useForceInit;
